export const EQUINET_TERMS_AND_CONDITIONS_PAGE =
    'https://www.equinetapp.com/termsandconditions';
export const EQUINET_PRIVACY_POLICY_PAGE =
    'https://www.equinetapp.com/privacypolicy';
export const EQUINET_SUPPORT_PAGE = 'https://www.equinetapp.com/contact';

export const EQUINET_WEBSITE = 'https://www.equinetapp.com/';
